module.exports = __webpack_public_path__ + "img/12.e78b5c35.jpg";